import { v7 as uuidv7 } from 'uuid'

/** A device-made id, `T<unique_no>-<UUIDv7>` (POS.md §16 Q24): unique across devices, sortable by time. */
export const newTempId = (terminalUniqueNo: number) => `T${terminalUniqueNo}-${uuidv7()}`

export const isTempId = (id: string | undefined) => !!id && /^T\d+-/.test(id)
